import React from 'react'
import Help from '../fetures/help/Help'

const HelpPage = () => {
  return (
    <Help/>
  )
}

export default HelpPage